import React, {FC} from 'react';

import {postActionData} from 'features/configure-table-report-actions-menu/api/api';
import {showMessageFromResponse} from 'shared/utils';
import {showRequestErrorMessage} from 'shared/utils/show-message-from-response';
import {ITableReportDataRequestParams} from 'store/slices/table-report-slice/table-report-slice-types';

import {IReportConfigurationAction} from '../../model/types';

interface IRunButtonActionProps {
  action: IReportConfigurationAction;
  selectedTableRows: number[];
  docId: string | null;
  templateCode: string | undefined;
  isAllRowsSelected: boolean;
  pageRequestDto?: Omit<ITableReportDataRequestParams, 'templateCode' | 'docId' | 'lookupType'>;
  handleRefreshReportPage?: () => void;
}

export const RunButtonAction: FC<IRunButtonActionProps> = ({
    action,
    selectedTableRows,
    docId,
    templateCode,
    isAllRowsSelected,
    pageRequestDto,
    handleRefreshReportPage,
    ...props
}: IRunButtonActionProps) => {
    const handleClick = async () => {
        try {
            const response = await postActionData({
                action: action.action,
                docId,
                templateCode,
                selectedTableRows,
                isAllRowsSelected,
                pageRequestDto,
            });
            showMessageFromResponse({response});
            handleRefreshReportPage?.();
        } catch (error) {
            showRequestErrorMessage(error);
        }
    };

    return (
        <span
            {...props}
            onClick={handleClick}
        >
            {action?.meaning || 'Выполнить действие'}
        </span>
    );
};
